export function getQueryStringValueByName(name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  const regexS = `[\\?&]${name}=([^&#]*)`;
  const regex = new RegExp(regexS);
  const results = regex.exec(window.location.href);
  if (results == null) {
    return '';
  }

  return decodeURIComponent(results[1].replace(/\+/g, ' '));
}

export function getURLParameter(name) {
  const regexResult = RegExp(`${name}=(.+?)(&|$)`).exec(location.search);
  return unescape(regexResult ? regexResult[1] : '');
}

// Regexes the domain from a URL string (excluding ports).
// Returns null if no match found.
export function getURLDomain(url) {
  const matches = url.match(/^https?:\/\/([^\/:?#]+)(?:[\/:?#]|$)/i);
  return matches && matches[1];
}

/**
 * @description
 * Converts a flat javascript object to a URL query string
 * [https://en.m.wikipedia.org/wiki/Query_string]
 *
 * @param  {Object}  obj     object (or array) to be converted
 * @param  {String}  newkey  provides a convenient way to specify a
 *                           fixed key name for each array elements
 *
 * @returns  {String}
 *
 * @example
 * this javascript object:
 *   {
 *     a: [1, 2, 3],
 *     b: ['x', 'y', 'z'],
 *     c: '= & ='
 *   }
 * is transformed to:
 *   "a[]=1&a[]=2&a[]=3&b[]=x&b[]=y&b[]=z&c=%3D%20%26%20%3D"
 *
 */
export function objectToQueryString(obj, newkey) {
  return Object.keys(obj)
    .map(key => {
      let keyval;
      if (obj[key] instanceof Array) {
        keyval = objectToQueryString(obj[key], `${key}[]`);
      } else {
        const k = newkey ? encodeURIComponent(newkey)
          : encodeURIComponent(key);
        const v = encodeURIComponent(obj[key]);
        keyval = `${k}=${v}`;
      }
      return keyval;
    })
    .join('&');
}
